// ** Routes Imports
import Leitura from './Leitura'
import Livros from './Livros'
import Login from './Login'
import RecuperarSenha from './RecuperarSenha'
import FaqRoute from './Faq'

// ** Document title
const TemplateTitle = '%s - Intuitiva'

// ** Default Route
const DefaultRoute = '/livros'

// ** Merge Routes
const Routes = [...Livros, ...Login, ...RecuperarSenha, ...Leitura, ...FaqRoute]

export { DefaultRoute, TemplateTitle, Routes }